// Single source of truth for metric ranges.
// Entries with a `sprinter` key use different bounds for sprinter athletes.
// Call ranges(isSprinter) to get a resolved map; each value has .lower, .upper, and .asString().

const METRIC_CONFIG = {
  footStrikeAngle:      { lower: 0,   upper: 5,        suspect: { lower: -Infinity, upper: 10  } },
  tibiaAngle:           { lower: 85,  upper: 95,       suspect: { lower: 80,        upper: 100 }, sprinter: { lower: 80,  upper: 90       } },
  overstride:           { lower: 0,   upper: 10,       suspect: { lower: -Infinity, upper: 20  } },
  kneeFlexion:          { lower: 45,  upper: Infinity, suspect: { lower: 30,        upper: 60  }, sprinter: { lower: 40,  upper: Infinity } },
  heelHeight:           { lower: 90,  upper: Infinity, suspect: { lower: 40,        upper: 150 }, sprinter: { lower: 110, upper: Infinity } },
  verticalDisplacement: { lower: 0,   upper: 8,        suspect: { lower: -Infinity, upper: 15  }, sprinter: { lower: 0,   upper: 6        } },
  trunkLean:            { lower: 7,   upper: 20,       suspect: { lower: -Infinity, upper: 30  }, sprinter: { lower: 2,   upper: 10       } },
  hipExtension:         { lower: 20,  upper: Infinity, suspect: { lower: -Infinity, upper: 35  } },
  cadence:              { lower: 170, upper: Infinity, suspect: { lower: 120,       upper: 290 }, sprinter: { lower: 245, upper: Infinity } },
  treadmillShaking:     { lower: 0,   upper: 3        },
  baseOfSupport:        { lower: 5,   upper: Infinity, suspect: { lower: -Infinity, upper: 10  } },
  kneeWindow:           { lower: 8,   upper: Infinity, suspect: { lower: -Infinity, upper: 15  } },
  toeOut:               { lower: 5,   upper: 10,       suspect: { lower: -Infinity, upper: 20  } },
  pelvicDrop:           { lower: 0,   upper: 5,        suspect: { lower: -Infinity, upper: 15  } },
  heelEversion:         { lower: 0,   upper: 10,       suspect: { lower: -Infinity, upper: 15  } },
  heelWhip:             { lower: 0,   upper: 20,       suspect: { lower: -Infinity, upper: 45  } },
};

const makeRange = ({ lower, upper }) => ({
  lower,
  upper,
  asString: () => upper === Infinity ? `${lower}+` : `${lower}-${upper}`,
});

export const ranges = (isSprinter = false) =>
  Object.fromEntries(
    Object.entries(METRIC_CONFIG).map(([key, { sprinter, suspect, ...base }]) => [
      key,
      makeRange(isSprinter && sprinter ? sprinter : base),
    ])
  );

export const suspectRanges = Object.fromEntries(
  Object.entries(METRIC_CONFIG).map(([key, { suspect }]) => [key, suspect || null])
);
